import { useState, useEffect, useContext } from 'react'
import isEmpty from 'lodash/isEmpty'
import { selectFeatureIncludes, FeatureDict } from '@authed/selectors'
import { userContext } from '@contexts'
import { Role, User } from '@global/types'
import { useAppSelector } from '@redux/hooks'

interface UserContextType {
  byId: Record<string, User>
  fetchUsers: () => Promise<any>
}

export function useFetchUsersWithApprovalPermission(requireApproval: boolean) {
  const { byId, fetchUsers } = useContext(userContext) as UserContextType
  const [usersWithApprovalPermission, setUsersWithApproverPermission] = useState<User[]>([])
  const [loadingUsers, setLoadingUsers] = useState(false)
  const [MANAGER_APPROVAL_ENABLED = false] = useAppSelector(
    selectFeatureIncludes([FeatureDict.MANAGER_APPROVALS]),
  )

  useEffect(() => {
    if (!requireApproval) return

    if (isEmpty(byId)) {
      setLoadingUsers(true)
      void fetchUsers().then(() => {
        setLoadingUsers(false)
      })
    }

    if (byId && isEmpty(usersWithApprovalPermission)) {
      const usersWithAdminOrManagerRole = Object.values(byId).filter(userCanApprove)
      setUsersWithApproverPermission(usersWithAdminOrManagerRole)
    }
  }, [requireApproval, byId])

  function userCanApprove(user) {
    if (user.role === Role.OWNER || (MANAGER_APPROVAL_ENABLED && user.role === Role.MANAGER)) {
      return true
    }
  }

  return { loadingUsers, usersWithApprovalPermission }
}
